/**
 * From https://codesandbox.io/s/react-select-v2-required-input-3xvvb?file=/src/FixRequiredSelect.js:64-1313
 * Adds support for the HTML5 required property to react-select
 * Turn off typechecking for this file cause the example was untyped and I'm lazy
 * Added currentValue prop to avoid weird collisions with parent Select value
 */
// @ts-nocheck

import React from "react";

const noop = () => {
  // no operation (do nothing real quick)
};

export class FixRequiredSelect extends React.Component {
  state = {
    value: this.props.value || "",
    currentValue: this.props.currentValue || "",
  };

  selectRef = null;
  setSelectRef = (ref) => {
    this.selectRef = ref;
  };

  onChange = (value, actionMeta) => {
    this.props.onChange(value, actionMeta);
    this.setState({ value, currentValue: value });
  };

  getCurrentValue = () => {
    if (this.props.currentValue != undefined) return this.props.currentValue;
    return this.state.currentValue || "";
  };

  render() {
    const { SelectComponent, required, ...props } = this.props;
    const { isDisabled } = this.props;
    const enableRequired = !isDisabled;

    return (
      <div>
        <SelectComponent
          {...props}
          ref={this.setSelectRef}
          onChange={this.onChange}
        />
        {enableRequired && (
          <input
            tabIndex={-1}
            autoComplete="off"
            style={{
              opacity: 0,
              width: "100%",
              height: 0,
              position: "absolute",
            }}
            value={this.getCurrentValue()}
            onChange={noop}
            onFocus={() => this.selectRef.focus()}
            required={required}
            onInvalid={this.props.onInvalid}
          />
        )}
      </div>
    );
  }
}
